import { Routes } from "@angular/router";
import { authGuard } from "./core/auth/auth.guard";

export const routes: Routes = [
  // Rotas públicas
  {
    path: "login",
    title: "Entrar | Josenilton Hub",
    loadComponent: () =>
      import("./features/login/login.component").then((m) => m.LoginComponent),
  },
  {
    path: "auth/callback",
    title: "Autenticação | Josenilton Hub",
    loadComponent: () =>
      import("./features/login/callback.component").then(
        (m) => m.CallbackComponent,
      ),
  },

  // Layout autenticado
  {
    path: "",
    canActivate: [authGuard],
    loadComponent: () =>
      import("./layouts/main-layout/main-layout.component").then(
        (m) => m.MainLayoutComponent,
      ),
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "dashboard",
      },
      {
        path: "dashboard",
        title: "Dashboard | Josenilton Hub",
        loadComponent: () =>
          import("./features/dashboard/dashboard.component").then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: "tasks",
        title: "Tarefas | Josenilton Hub",
        loadComponent: () =>
          import("./features/tasks/tasks.component").then(
            (m) => m.TasksComponent,
          ),
      },
      {
        path: "calendar",
        title: "Calendário | Josenilton Hub",
        loadComponent: () =>
          import("./features/calendar/calendar.component").then(
            (m) => m.CalendarComponent,
          ),
      },
      {
        path: "agents",
        title: "Agentes | Josenilton Hub",
        loadComponent: () =>
          import("./features/agents/agents.component").then(
            (m) => m.AgentsComponent,
          ),
      },
      {
        path: "agents/job-hunter",
        title: "Job Hunter | Josenilton Hub",
        loadComponent: () =>
          import("./features/agents/job-hunter/job-hunter.component").then(
            (m) => m.JobHunterComponent,
          ),
      },
      {
        path: "notes",
        title: "Notas | Josenilton Hub",
        loadComponent: () =>
          import("./features/notes/notes.component").then(
            (m) => m.NotesComponent,
          ),
      },
      {
        path: "projects",
        title: "Projetos | Josenilton Hub",
        loadComponent: () =>
          import("./features/projects/projects.component").then(
            (m) => m.ProjectsComponent,
          ),
      },
      {
        path: "files",
        title: "Arquivos | Josenilton Hub",
        loadComponent: () =>
          import("./features/files/files.component").then(
            (m) => m.FilesComponent,
          ),
      },
      {
        path: "configuration",
        title: "Configurações | Josenilton Hub",
        loadComponent: () =>
          import("./features/configuration/configuration.component").then(
            (m) => m.ConfigurationComponent,
          ),
      },
      {
        path: "profile",
        title: "Perfil | Josenilton Hub",
        loadComponent: () =>
          import("./features/profile/profile.component").then(
            (m) => m.ProfileComponent,
          ),
      },
    ],
  },

  // Rota desconhecida
  {
    path: "**",
    redirectTo: "dashboard",
  },
];
